import axios from 'axios'

export const keySession = "timesheet-user-session";
export const keyUserAccess = "timesheet-user-access";
export const keyUserTheme = "timesheet-user-theme";
export const keyUseri18next = "timesheet-user-i18next";
export const keyGestao = 'R7fyhOU1RxNYnMHjh20NcVYo+ED1h89LfYHolCZCLP4';

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASEURL
});

export const apiNoAuth = axios.create({
  baseURL: process.env.REACT_APP_BASEURL
});

api.interceptors.request.use(async (config: any) => {
  try {
    const storageValue = localStorage.getItem(keySession)
    if (storageValue) {
      const header = JSON.parse(storageValue)
      if (header.token && header.email) {
        config.headers.Authorization = `Bearer ${header.token}`;
        config.headers.Email = header.email;
      } else {
        localStorage.removeItem(keySession)
        localStorage.removeItem(keyUserAccess)
        window.location.replace("/login"); 
      }
    }
  } catch (error) {
    localStorage.removeItem(keySession)
    localStorage.removeItem(keyUserAccess)
    console.log(error)
  }
  return config;
});

api.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.hasOwnProperty('response')) {
    switch (error.response.status) {
      case 400:
        break;
      case 401:
        localStorage.removeItem(keySession);
        window.location.replace("/login"); 
        break;
      case 500:
        break;
      default:
        console.log(`Sorry, we are out of ${error.response.status}.`);
    }
    return error.response;
  }
})
